import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import DefaultLayout from "./layout/DefaultLayout";
import Home from "./Pages/faceswap/Home";
import Api from "./Pages/faceswap/Api";
import Filter from "./Pages/faceswap/Filter";
import Photos from "./Pages/faceswap/Photos";
import PhotoDetails from "./Pages/faceswap/PhotoDetails";
import AiAvatar from "./Pages/ai-avatar/AiAvatar";
import Styles from "./Pages/ai-avatar/Styles";
import Login from "./components/login/Login";
import NotFound from "./Pages/NotFound";
import Videos from "./Pages/faceswap/videos/Videos";
import VideoDetails from "./Pages/faceswap/videos/VideoDetails";

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFound />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DefaultLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Home />} />
          <Route path="faceswap">
            <Route index element={<Api />} />
            <Route path="photos" element={<Photos />}>
              <Route path=":mediaId" element={<PhotoDetails />} />
            </Route>

            <Route path="videos" element={<Videos />}>
              <Route path=":mediaId" element={<VideoDetails />} />
            </Route>

            <Route path="filter" element={<Filter />} />
          </Route>
        </Route>

        <Route
          path="ai-avatar"
          element={
            <ProtectedRoute>
              <DefaultLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AiAvatar />} />
          <Route path="styles" element={<Styles />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
